import { type FC } from 'react';
import Divider from '@material-ui/core/Divider';
import cx from 'classnames';

import { IconArrow24 } from 'src/assets/icons/24x24/IconArrow24';
import {
  CUSTOM_ICON_BUTTON_SIZE,
  CUSTOM_ICON_BUTTON_VARIANT,
  CustomIconButton,
} from 'src/components/CustomIconButton';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { type EditorType } from 'src/data/project';
import { type Callback } from 'src/lib/types';

import { WIDGET_ACTION, type WidgetAction } from '../../lib';

import { EditorTypeDropdown } from './components/EditorTypeDropdown';
import styles from './styles.module.scss';

interface PromptFooterActionsProps {
  className?: string;
  onAction: Callback<WidgetAction>;
  disabled: boolean;
  loading: boolean;
  allowedSubmit: boolean;
  hasUploadingResources: boolean;
  onEditorChange: Callback<EditorType>;
  editorType: EditorType;
}

export const PromptFooterActions: FC<PromptFooterActionsProps> = ({
  className,
  onAction,
  disabled,
  loading,
  allowedSubmit,
  hasUploadingResources,
  onEditorChange,
  editorType,
}) => {
  return (
    <div
      className={cx(styles.root, className, {
        [styles.allowedSubmit]: allowedSubmit,
      })}
    >
      <EditorTypeDropdown
        onChange={onEditorChange}
        editorType={editorType}
      />
      <Divider
        className={styles.divider}
        orientation="horizontal"
      />
      <CustomTooltip title={hasUploadingResources ? 'Upload in progress' : ''}>
        <span>
          <CustomIconButton
            className={styles.buttonSubmit}
            onClick={() => onAction(WIDGET_ACTION.submitPrompt)}
            disabled={disabled || hasUploadingResources || !allowedSubmit}
            loading={loading}
            variant={CUSTOM_ICON_BUTTON_VARIANT.primary}
            size={CUSTOM_ICON_BUTTON_SIZE.large}
          >
            <IconArrow24 className={styles.iconSubmit} />
          </CustomIconButton>
        </span>
      </CustomTooltip>
    </div>
  );
};
